import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import AboutUs from '../components/section/about_us';
import AcademicsPage from '../components/section/academics';
import Beyond from '../components/section/beyond_academics';
import Career from '../components/section/career';
import Cbse from '../components/section/cbse';
import DeliverPage from '../components/section/deliver_inspiration';
import ImpressionsPage from '../components/section/impressions';
import Infrastructure from '../components/section/infrastructure';
import LifeAtInnovera from '../components/section/life_at_innovera';
  import config from '../constant';


class InspireMain extends Component {
    componentDidMount(){
        document.title = "Deliver Inspiration | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <DeliverPage/>
             <Footer/>


        </div>
    );

}
    }
export default InspireMain;